import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import FAQSection from './components/FAQSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <MediaSection />
        <AppSection />
        <AboutSection />
        <FAQSection />
        <TopicsSection />
        <UpdatesSection />
        <CommentsSection />
        <CardsSection />
        <ContactSection />
        <RankingSection />
        <FeaturesSection />
        <IndexSection />
      </main>
      <Footer />
    </div>
  );
}